import { HttpMethods, makeRequest } from "../helpers/http.helper";
import {
  CatalogPlaybackResponse,
  CatalogUnlinkResponse,
  CatalogVideoLinkResponse,
  WorkoutCatalogResponse,
} from "../types/workout-catalog.type";

const unwrap = <T>(response: { result?: T } & T): T =>
  (response?.result ?? response) as T;

export const getWorkoutCatalog = async (): Promise<WorkoutCatalogResponse> => {
  const response = await makeRequest({
    url: "/workouts/catalog",
    method: HttpMethods.GET,
  });
  return unwrap<WorkoutCatalogResponse>(response);
};

export const attachCatalogVideo = async (
  catalogId: string,
  assetId: string
): Promise<CatalogVideoLinkResponse> => {
  const response = await makeRequest({
    url: `/workouts/catalog/${catalogId}/video`,
    method: HttpMethods.PUT,
    data: { asset_id: assetId },
  });
  return unwrap<CatalogVideoLinkResponse>(response);
};

export const detachCatalogVideo = async (
  catalogId: string
): Promise<CatalogUnlinkResponse> => {
  const response = await makeRequest({
    url: `/workouts/catalog/${catalogId}/video`,
    method: HttpMethods.DELETE,
  });
  return unwrap<CatalogUnlinkResponse>(response);
};

export const getCatalogPlayback = async (
  catalogId: string
): Promise<CatalogPlaybackResponse> => {
  const response = await makeRequest({
    url: `/workouts/catalog/${catalogId}/playback`,
    method: HttpMethods.GET,
  });
  return unwrap<CatalogPlaybackResponse>(response);
};
